import { message } from "antd";
export const showMessage = (text, type) => {
  message.open({
    type: type || "info",
    content: text,
  });
};
